<div class='table table-striped col'>
  <div class='table-header row secondary-color text-white mt-3'>
    <div class="cell-data col d-print-none" *ngIf="showViewLink">View</div>
    <div class="cell-data col">Scale</div>
    <div class="cell-data col-3">Description</div>
    <div class="cell-data col">Raw Score / Total</div>
    <div class="cell-data col">Severity <i class="fa fa-clipboard float-right" (click)="copyTable()" title="Copy Table" alt="Copy Table"></i></div>
  </div>
  <div *ngFor="let scaleResult of scaleResults" class="row" [ngClass]="getScaleResultClassNames(scaleResult)">
    <div class="col d-print-none cell-data" *ngIf="showViewLink">
        <button class="m-0 btn btn-primary btn-sm" (click)="goToScaleResult(scaleResult)">
            <span class="fa fa-bar-chart"></span>
          </button>
    </div>
    <div class="col cell-data">
        {{getMaxName(scaleResult.scale)}}</div>
      <div class="col-3 cell-data text-small">{{scaleResult.scale.descriptionTherapist}}</div>
      <div class="col cell-data">{{scaleResult.score}} / {{getTotalPossibleForResult(scaleResult)}}</div>
      <div class="col cell-data">{{getLabelNameForRange(scaleResult)}}</div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/scale-results-table-summary/scale-results-table-summary.component.html